import { render, staticRenderFns } from "./OnestopDetail.vue?vue&type=template&id=5b2ec746"
import script from "./OnestopDetail.vue?vue&type=script&lang=js"
export * from "./OnestopDetail.vue?vue&type=script&lang=js"
import style0 from "./OnestopDetail.vue?vue&type=style&index=0&id=5b2ec746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports